import React, { useState } from "react";
import { Form, OverlayTrigger, Popover } from "react-bootstrap";
import { DayPicker } from "react-day-picker";
import { format, isValid } from "date-fns";
import "react-day-picker/dist/style.css";
import { DATE_FORMAT, DATE_TYPES } from "configurations/Constants";

function DateRangePicker({ label, dateRange, setDateRange }) {
  const [showPicker, setShowPicker] = useState(false);

  const handleDayClick = (day) => {
    const { from, to } = dateRange;

    if (from && to) {
      setDateRange({ from: null, to: null });

      return;
    }
    if (!from) {
      setDateRange({ from: day, to: null });
      return;
    }
    const newRange = day > from ? { from, to: day } : { from: day, to: from };
    setDateRange(newRange);
    setShowPicker(false);
  };

  const popover = (
    <Popover id="calendar-dateRange-popover">
      <Popover.Body>
        <DayPicker
          key={`${dateRange.from}-${dateRange.to}`}
          mode={DATE_TYPES.RANGE}
          selected={dateRange}
          onDayClick={handleDayClick}
          numberOfMonths={1}
        />
      </Popover.Body>
    </Popover>
  );

  const formattedStart = isValid(dateRange?.from)
    ? format(dateRange.from, DATE_FORMAT)
    : "";
  const formattedEnd = isValid(dateRange?.to)
    ? format(dateRange.to, DATE_FORMAT)
    : "";

  return (
    <>
      <Form.Label>{label}</Form.Label>
      <OverlayTrigger
        trigger="click"
        placement="bottom"
        overlay={popover}
        show={showPicker}
        rootClose
        onToggle={() => setShowPicker(!showPicker)}
      >
        <div
          className="d-flex align-items-center justify-content-between gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => setShowPicker(!showPicker)}
        >
          <div className="position-relative">
            <Form.Control
              readOnly
              type="text"
              value={formattedStart}
              placeholder="MM/DD/YYYY"
              className="input-underline"
            />
            <i className="fa-regular fa-calendar position-absolute end-0 top-50 translate-middle-y p-2 text-muted"></i>
          </div>
          <span className="mx-2"> → </span>
          <div className="position-relative">
            <Form.Control
              readOnly
              type="text"
              value={formattedEnd}
              placeholder="MM/DD/YYYY"
              className="input-underline"
            />
            <i className="fa-regular fa-calendar position-absolute end-0 top-50 translate-middle-y p-2 text-muted"></i>
          </div>
        </div>
      </OverlayTrigger>
    </>
  );
}

export default DateRangePicker;
